import apiService from '../Api'
import { IUser } from '../User/UserService'

export interface IList {
  current_page: number
  per_page: number
  total: number
  total_selected: number
  data: IUserGroup[]
}

export interface IUserGroup {
  id: number
  name: string
  created_by: string
  created_at: string
  updated_at: string
  roles: IRole[]
  creator: IUser
}

export interface IRole {
  id: number
  role_group_id: number
  name: string
  slug: string
  order: number
  created_at: string
  updated_at: string
}

export interface ICreateUpdateUserGroup {
  name: string
  permissions: number[]
}

export interface IRoleGroup {
  id: number
  name: string
  order: number
  children: IRoleGroup[]
  roles: IRole[]
}

export class UserGroupService {
  async list(filters: { page?: number; pageSize?: number } = {}): Promise<IList> {
    return apiService
      .get('/user-group', {
        params: {
          page: filters.page ?? 1,
          page_size: filters.pageSize ?? 10
        }
      })
      .then((response) => response.data)
  }

  async listForSelect(): Promise<IUserGroup[]> {
    return apiService.get('/user-group/select').then((response) => response.data)
  }

  async listSystemRoles(): Promise<IRoleGroup[]> {
    return apiService.get('/user-group/system-roles').then((response) => response.data)
  }

  async create(data: ICreateUpdateUserGroup): Promise<IUserGroup> {
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('permissions', JSON.stringify(data.permissions))

    return apiService.post('/user-group', formData).then((response) => response.data)
  }

  async update(userGroupId: number, data: ICreateUpdateUserGroup): Promise<IUser> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('name', data.name)
    formData.append('permissions', JSON.stringify(data.permissions))

    return apiService
      .post(`/user-group/${userGroupId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => response.data)
  }

  async destroy(id: number) {
    return apiService.delete(`/user-group/${id}`).then((response) => response.data)
  }
}
